export { outdatedDepsOfProjects } from './outdatedDepsOfProjects.ts';
export type { OutdatedPackage } from './outdated.ts';
